import { render, staticRenderFns } from "./Directors.vue?vue&type=template&id=25db98a8&scoped=true&"
import script from "./Directors.vue?vue&type=script&lang=js&"
export * from "./Directors.vue?vue&type=script&lang=js&"
import style0 from "./Directors.vue?vue&type=style&index=0&id=25db98a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db98a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
